import React from 'react';
import { PageSEO } from '@/components/seo/SEOHelmet';

const CountryPage = () => {
    return (
        <div className="min-h-screen" data-testid="country-page">
            <PageSEO title="Country" description="Explore recipes from this country." path="/country" />
            <section className="max-w-4xl mx-auto px-4 py-16">
                <h1 className="text-4xl mb-4">Country Page</h1>
                <p>Coming soon...</p>
            </section>
        </div>
    );
};

export default CountryPage;